import styled from "styled-components";

export const BookingOverviewContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftViewSectionContainer = styled.div`
  flex: 2.5;
  padding: 2rem 0 2rem 2rem;

  @media only screen and (max-width: 786px) {
    padding: 1.5rem;
  }
`;

export const RightViewSectionContainer = styled.div`
  flex: 1.5;
  // background-color: #edecea;

  @media only screen and (max-width: 1000px) {
    display: none;
  }
`;

export const Overview = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.5rem 0;
`;

export const CakeView = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
  @media only screen and (max-width: 500px) {
    justify-content: space-between;
    gap: 0rem;
    margin-top: 1rem;
  }
`;

export const OccasionView = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem;

  @media only screen and (max-width: 500px) {
    margin: 0.5rem;
    width: 40%;
    text-align: center;
  }
`;

export const OccasionTitle = styled.section`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-top: 0.4rem;
  align-self: normal;
`;

export const OccasionPrice = styled.section`
  // display: flex;
    align-self: normal
`;

export const BackButtonContainer = styled.div`
  flex: 0.5;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  // padding-bottom: 2rem;
`;

export const BackButtonTxt = styled.div``;

export const HeadingContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 786px) {
    margin-bottom: 1rem;
  }
`;

export const HeadingTxt = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 35px;

  @media only screen and (max-width: 786px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const OptionalContainer = styled.div`
  display: flex;
  // justify-content: flex-end;
  align-items:center;
`;

export const ImgContainer = styled.div`
  background-color: #ffffff;
  border-radius: 50%;
  width: 160px;
  height: 160px;
  box-shadow: 0px 10px 35px 0px #575c8a1f;
  position: relative;

  @media only screen and (max-width: 786px) {
    width: 130px;
    height: 130px;
  }
`;

export const TickImageContainer = styled.img`
  position: relative;
  top: 35%;
  left: 35%;
  z-index: 100;

  @media only screen and (max-width: 500px) {
    left: 0%;
  }
`;

export const MwebFooterContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

export const PriceBreakupSummaryContainer = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #e3e2e0;
    border-radius: 16px;
    margin: 2rem 0;
  }
`;

export const PriceBreakupHeader = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    background-color: #e3e2e0;
    flex: 1;
    padding: 0.7rem 0;
    border-radius: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const PriceBreakup = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex: 1;
    margin: 1.5rem 0.7rem;
  }
`;

export const PriceBreakupTotal = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex: 1;
    margin: 0.7rem;
  }
`;

export const PriceBreakupPrice = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    margin: 0.7rem;
  }
`;

export const BookNowBtn = styled.button`
  display: flex;
  justify-content: center;
  background-color: #34265c;
  color: white;
  border: none;
  border-radius: 64px;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  padding: 1rem;
  font-family: Montserrat;
`;

export const BookingSummaryHeading = styled.div`
  display: flex;
  flex: 1;
`;

export const BookingSummaryTxt = styled.h3`
  display: flex;
  flex: 1;
  text-decoration: underline;
  color: #34255c;
`;

export const Actions = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding-top: 1rem;
  display: flex;
`;

export const Checkbox = styled.input`
  accent-color: #34265c;
  border-color: #34265c;
  border: 5px solid #34265c;
  width: 1.5rem;
  height: 1.5rem;
`;

export const AgreeBox = styled.div`
  margin-left: 0.5rem;
  top: 0.3rem;
  position: relative;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`;

export const FoodInstruction = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const Instruction = styled.div`
  background-color: #f3f0f9;
  border: 1px solid #cacaca;
  border-radius: 16px;
  padding: 1rem;
`;

export const PleaseNoteHeading = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 0.5rem;
`;
export const PleaseNoteTxt = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const PriceBreakupDetails = styled.div`
  flex: 1;
`;

export const InputContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  flex: 0.7;
  gap: 0.5rem;
  flex-direction: column;
  @media only screen and (max-width: 786px) {
    flex: 1;
  }
`;

export const LabelBox = styled.label``;

export const FogEntryCountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const PopularTag = styled.div`
z-index:1000;
    display: flex;
padding: 5px 10px;
justify-content: center;
align-items: center;
gap: 2px;
position: absolute;
top: 12px;
right:0px;
border-radius: 6px;
background: var(--Popular-tag, linear-gradient(98deg, #9B2915 7.07%, #FF9000 90.3%));
`
export const PopularText = styled.div`
color: var(--Neutral-Grey-grey-1, #FFF);
text-align: center;

/* Paragraph/2XS/P-2XS */
font-family: "DM Sans", sans-serif;
font-size: var(--Font-Size-Paragraph-p-2xs, 12px);
font-style: normal;
font-weight: 400;
line-height: var(--Line-Height-Paragraph-2xs, 14px); /* 140% */
`


